module.exports = __webpack_public_path__ + "assets/img/type3.ab350376.png";